import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  layout: {},
  isLoading: false,
  error: "",
  hasData: false,
  layoutModal: false
};
const flightLayoutSlice = createSlice({
  name: "flightLayout",
  initialState,
  reducers: {
    layoutRequest: state => {
      state.isLoading = true;
    },
    layoutSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.layout = action.payload;
    },
    layoutFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.hasData = false;
    },
    setLayoutOpen: state => {
      state.layoutModal = true;
    },
    setLayoutClose: state => {
      state.layoutModal = false;
    }
  }
});
export const {
  layoutRequest,
  layoutSuccess,
  layoutFailure,
  setLayoutOpen,
  setLayoutClose
} = flightLayoutSlice.actions;
export default flightLayoutSlice.reducer;